module.exports = __webpack_public_path__ + "img/Priest-troll-f-70.81d20c24.gif";